module.exports = __webpack_public_path__ + "static/media/gateway-offline.37b3eb56.svg";